import {
  Game,
  wireSpellSpriteDevPanel,
  wireTooltips,
} from "./client";
import { isMobileDevice } from "./mobile-gate";
import { wireSpellPreview } from "./preview";

window.addEventListener("DOMContentLoaded", () => {
  if (isMobileDevice()) return;
  wireTooltips();
  wireSpellSpriteDevPanel();
  wireSpellPreview();
  window.game = new Game();
});
